import { IArticleAndAttachments } from "../../models/article.ts";
import { ICSVFormat } from "../../models/csv_format.ts";

export const transformFromArticleToCSV = (
  articleAndAttachments: IArticleAndAttachments,
  formatBodyForCsv: (body: string) => string,
): ICSVFormat => {
  const article = articleAndAttachments.article;
  const attachments = articleAndAttachments.attachments.filter(
    (a) => !a.inline,
  );

  const getAttachmentName = (index: number): string => {
    return attachments[index]?.display_file_name || "";
  };

  return {
    id: article.id,
    author_id: article.author_id,
    title: article.title,
    body: formatBodyForCsv(article.body),
    draft: article.draft,
    category_id: article.category_id,
    section_id: article.section_id,
    permission_group_id: article.permission_group_id,
    user_segment_id: article.user_segment_id,
    label_name1: article.label_names[0] ? article.label_names[0] : "",
    label_name2: article.label_names[1] ? article.label_names[1] : "",
    label_name3: article.label_names[2] ? article.label_names[2] : "",
    label_name4: article.label_names[3] ? article.label_names[3] : "",
    label_name5: article.label_names[4] ? article.label_names[4] : "",
    label_name6: article.label_names[5] ? article.label_names[5] : "",
    label_name7: article.label_names[6] ? article.label_names[6] : "",
    label_name8: article.label_names[7] ? article.label_names[7] : "",
    label_name9: article.label_names[8] ? article.label_names[8] : "",
    label_name10: article.label_names[9] ? article.label_names[9] : "",
    content_tag_id1: article.content_tag_ids[0]
      ? article.content_tag_ids[0]
      : "",
    content_tag_id2: article.content_tag_ids[1]
      ? article.content_tag_ids[1]
      : "",
    content_tag_id3: article.content_tag_ids[2]
      ? article.content_tag_ids[2]
      : "",
    content_tag_id4: article.content_tag_ids[3]
      ? article.content_tag_ids[3]
      : "",
    content_tag_id5: article.content_tag_ids[4]
      ? article.content_tag_ids[4]
      : "",
    attachment_name1: getAttachmentName(0),
    attachment_name2: getAttachmentName(1),
    attachment_name3: getAttachmentName(2),
    attachment_name4: getAttachmentName(3),
    attachment_name5: getAttachmentName(4),
    created_at: article.created_at,
    updated_at: article.updated_at,
  };
};
